module.exports = __webpack_public_path__ + "static/media/IMG_4264.33276608.PNG";